const SidePurlinPartsHobby = (nodes, materials, metal, antiHotSpotTape, lengthToAdd, scale) => (
  <group key="hobby-side-purlin-parts">
    <mesh name="32mm_Brace_Bracket004" geometry={nodes['32mm_Brace_Bracket004'].geometry} position={[-0.014, 0.028, -0.008]} rotation={[-0.895, -0.046, -1.508]}>
      {metal}
      {/* <mesh name="Mesh_1010" geometry={nodes.Mesh_1010.geometry} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
        {metal}
      </mesh>
      <mesh name="Mesh_2010" geometry={nodes.Mesh_2010.geometry} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
        {metal}
      </mesh>
      <mesh name="Mesh_3010" geometry={nodes.Mesh_3010.geometry} position={[0.028, 0.006, -0.02]} rotation={[-Math.PI, -0.052, 2.979]} >
        {metal}
      </mesh>
      <mesh name="Mesh_4012" geometry={nodes.Mesh_4012.geometry} position={[0.029, 0.006, -0.007]} rotation={[-Math.PI, -0.052, 2.979]} >
        {metal}
      </mesh> */}
    </mesh>
    <group position={[-0.003, 0.014, 0.326 + lengthToAdd]}>
      <mesh name="MOVE003" geometry={nodes.MOVE003.geometry} >
        {metal}
      </mesh>
      <mesh name="32mm_Brace_Bracket005" geometry={nodes['32mm_Brace_Bracket005'].geometry} position={[0.014, 0.018, 3.668]} rotation={[-2.067, -0.054, 1.539]}>
        {metal}
        {/* <mesh name="Mesh_1011" geometry={nodes.Mesh_1011_1.geometry} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
          {metal}
        </mesh> */}
        {/* <mesh name="Mesh_2011" geometry={nodes.Mesh_2011.geometry} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
          {metal}
        </mesh>
        <mesh name="Mesh_3011" geometry={nodes.Mesh_3011.geometry} position={[0.028, 0.006, -0.023]} rotation={[Math.PI, -0.052, 2.979]} >
          {metal}
        </mesh>
        <mesh name="Mesh_4014" geometry={nodes.Mesh_4014.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
          {metal}
        </mesh> */}
      </mesh>
    </group>
    <mesh name="SCALE" geometry={nodes.SCALE.geometry} position={[-0.003, 0.014, 0.301]} scale={[1, 1, scale]}>
      {metal}
      {/* <mesh name="ANTI-HOT-TAPE" geometry={nodes['ANTI-HOT-TAPE'].geometry} material={nodes['ANTI-HOT-TAPE'].material} /> */}
    </mesh>
  </group>
)

export default SidePurlinPartsHobby